import { request } from "../../../Services/Api"

const BASE_URL = "/consumer-clarity"

const PATHS = {
  configurePrograms: `${BASE_URL}/configure/business/programs/`,
  dashboardState: `${BASE_URL}/dashboard/state/`,
  dashboardKpi: `${BASE_URL}/dashboard/kpi/`,
  dashboardLookups: `${BASE_URL}/dashboard/lookups/`,
  dashboardExport: `${BASE_URL}/dashboard/export/`,
  faq: `${BASE_URL}/faq/`
}

export const getReceiptState = ({ business_account_id }) =>
  request.api.get(PATHS.dashboardState, { business_account_id })

// `channel` is part of the KPI scope, not only the table's: the filter bar's Channel
// control recalculates the cards too (§BLOCK 2), so Lookup fees sums the fees of the
// selected channel rather than of every fee under the selected program.
export const getReceiptKpi = ({ business_account_id, program, channel }) =>
  request.api.get(PATHS.dashboardKpi, { business_account_id, program, channel })

export const getReceiptLookups = (params) => request.api.get(PATHS.dashboardLookups, params)

// §BLOCK 4.2 — Export. Takes the same query params as the lookups list, because the
// backend validates both with the same serializer: the file can only ever answer the
// question the table is showing. Answers 202 with a task id; the CSV arrives by email.
export const getReceiptExport = (params) => request.api.get(PATHS.dashboardExport, params)

export const getReceiptFaq = () => request.api.get(PATHS.faq)
